import React from "react";
import { useFormContext } from "react-hook-form";
import { Input } from "../ui/Input";
import { Label } from "../ui/Label";

export function CompanyInfoStep() {
  const { register } = useFormContext();

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="legalCompanyName">Legal Company Name</Label>
          <Input
            id="legalCompanyName"
            {...register("legalCompanyName")}
            required
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="federalId">Federal ID#</Label>
          <Input id="federalId" {...register("federalId")} required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="typeOfBusiness">Type of Business</Label>
          <Input id="typeOfBusiness" {...register("typeOfBusiness")} required />
        </div>
        <div className="space-y-2">
          <Label htmlFor="wholesaleLicense">Wholesale License #</Label>
          <Input id="wholesaleLicense" {...register("wholesaleLicense")} />
        </div>
      </div>

      <div className="space-y-2">
        <Label>Legal Status</Label>
        <div className="flex flex-wrap gap-4">
          {["Sole Proprietorship", "Partnership", "LLC/LLP"].map((status) => (
            <label key={status} className="flex items-center space-x-2">
              <input
                type="radio"
                value={status}
                {...register("legalStatus")}
                className="h-4 w-4 text-slate-900 border-slate-300 focus:ring-slate-900"
              />
              <span className="text-sm font-medium">{status}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="yearEstablished">Year Established</Label>
          <Input id="yearEstablished" {...register("yearEstablished")} />
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-medium border-b pb-2">
          Contact Information
        </h3>
        <div className="space-y-2">
          <Label htmlFor="billingAddress">Billing/Mailing Address</Label>
          <Input
            id="billingAddress"
            {...register("billingAddress")}
            placeholder="Street Address"
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="space-y-2">
            <Label htmlFor="city">City</Label>
            <Input id="city" {...register("city")} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="state">State</Label>
            <Input id="state" {...register("state")} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="zipcode">Zipcode</Label>
            <Input id="zipcode" {...register("zipcode")} />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="space-y-2">
            <Label htmlFor="mainPhone">Main Phone #</Label>
            <Input id="mainPhone" type="tel" {...register("mainPhone")} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="generalContactMobile">General Contact Mobile</Label>
            <Input id="generalContactMobile" type="tel" {...register("generalContactMobile")} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="website">Website</Label>
            <Input id="website" type="url" {...register("website")} />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <Label htmlFor="generalContact">General Contact</Label>
            <Input id="generalContact" {...register("generalContact")} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="generalContactEmail">General Contact Email</Label>
            <Input
              id="generalContactEmail"
              type="email"
              {...register("generalContactEmail")}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="apContact">A/P Contact</Label>
            <Input id="apContact" {...register("apContact")} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="apContactEmail">A/P Contact Email</Label>
            <Input
              id="apContactEmail"
              type="email"
              {...register("apContactEmail")}
            />
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-medium border-b pb-2">
          Property & History
        </h3>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Do you own the business property?</Label>
            <div className="flex gap-4">
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="Yes"
                  {...register("ownProperty")}
                  className="h-4 w-4"
                />
                <span className="text-sm">Yes</span>
              </label>
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="No"
                  {...register("ownProperty")}
                  className="h-4 w-4"
                />
                <span className="text-sm">No</span>
              </label>
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="propertyOwnedBy">
              If not, property is owned by:
            </Label>
            <Input id="propertyOwnedBy" {...register("propertyOwnedBy")} />
          </div>
          <div className="space-y-2">
            <Label>Have you operated under another business name?</Label>
            <div className="flex gap-4">
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="Yes"
                  {...register("otherBusinessName")}
                  className="h-4 w-4"
                />
                <span className="text-sm">Yes</span>
              </label>
              <label className="flex items-center space-x-2">
                <input
                  type="radio"
                  value="No"
                  {...register("otherBusinessName")}
                  className="h-4 w-4"
                />
                <span className="text-sm">No</span>
              </label>
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="previousBusinessName">
              If yes, what was the previous business name?
            </Label>
            <Input
              id="previousBusinessName"
              {...register("previousBusinessName")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
